import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'
import { Dialogs, useDialogs } from '../../../sharedComponents/src/Contexts/DialogsContext'
import AnimatedDialog from '../../../sharedComponents/src/Dialogs/Common/AnimatedDialog'
import { analyticsManager } from '../../../sharedComponents/src/globalHeader/services/analytics/AnalyticsManager'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import StreakBanner from './StreakBanner'

const DailyPuzzleFeedback: React.FC = () => {
    const { isMobile } = useScreenSize()
    const { unregisterDialog } = useDialogs()

    const puzzleId = useStoreState((state) => state.dailyPuzzleView.puzzleId)
    const streak = useStoreState((state) => state.dailyPuzzleView.streak)
    const feedbackMessage = useStoreState((state) => state.dailyPuzzleView.feedbackMessage)
    const showStreak = useStoreState((state) => state.dailyPuzzleView.showStreak)

    const setShowFeedbackDialog = useStoreActions((state) => state.dailyPuzzleView.setShowFeedbackDialog)
    const setShowStreak = useStoreActions((state) => state.dailyPuzzleView.setShowStreak)
    const setFeedbackMessage = useStoreActions((state) => state.dailyPuzzleView.setFeedbackMessage)

    const onCloseHandler = () => {
        analyticsManager.dispatchEvent('feedbackPopupClosed', {
            puzzleId: puzzleId || '',
            feature: 'dailyPuzzle',
        })
        unregisterDialog(Dialogs.DAILY_PUZZLE_FEEDBACK)
        setShowFeedbackDialog(false)
        setShowStreak(false)
        setFeedbackMessage('')
    }

    return (
        <AnimatedDialog
            name={Dialogs.DAILY_PUZZLE_FEEDBACK}
            borderColor="secondary.main"
            paddingLess
            paperProps={{
                animationOrImage: {
                    src: `/assets/animations/puzzles/daily-puzzle-feedback.lottie`,
                    verticalPosition: {
                        xs: '-190px',
                        md: '-220px',
                    },
                    horizontalPosition: {
                        xs: '-12%',
                        md: '75px',
                    },
                },
                closeIcon: {
                    hide: true,
                },
            }}
        >
            <Stack
                gap={{ xs: 2, md: 3 }}
                alignItems="center"
                sx={{
                    pt: { xs: showStreak ? '0px' : '30px', md: showStreak ? '20px' : '60px' },
                    pb: { xs: '16px', md: '32px' },
                    px: { xs: '16px', md: '24px' },
                }}
            >
                {/* Content */}
                {showStreak && <StreakBanner value={streak} title="Day Streak" />}
                <Typography variant={isMobile ? 'body4' : 'body3'}>{feedbackMessage}</Typography>

                {/* Actions */}
                <Button variant="contained" size={isMobile ? 'medium' : 'large'} onClick={onCloseHandler}>
                    Close
                </Button>
            </Stack>
        </AnimatedDialog>
    )
}

export default DailyPuzzleFeedback
